const relationId = value => typeof value === 'string' ? value : value && value._id;

// This only controls displayed options. Backend relation validation remains
// authoritative, including for legacy jobs whose department link is missing.
export function getDepartmentJobTypes(section, departmentId, departmentOptions) {
  const id = relationId(departmentId);
  if (!section || section.isActive === false || typeof id !== 'string' || !/^(?:[a-f\d]{24}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.test(id)) return [];
  if (!departmentOptions.some(option => !option.disabled && relationId(option.value || option) === id)) return [];

  const activeJobs = (section.subCategories || []).filter(job => job && job.isActive !== false);
  const matches = activeJobs.filter(job => relationId(job.department) === id);
  if (matches.length) return matches;

  // Compatibility for genuinely absent references; an explicit link to another
  // department is never a fallback candidate, even if no matching job exists.
  return activeJobs.filter(job => !job.department);
}
